import { render, staticRenderFns } from "./cyfile.vue?vue&type=template&id=5f897804&scoped=true&"
import script from "./cyfile.vue?vue&type=script&lang=js&"
export * from "./cyfile.vue?vue&type=script&lang=js&"
import style0 from "./cyfile.vue?vue&type=style&index=0&id=5f897804&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f897804",
  null
  
)

export default component.exports